import axiosInstance from "../../axios";
import { GET_RISK_ASSESSMENT_REQUEST } from "../types/riskAssessmentTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { alertSuccess } from "../../utils/feedback";

export const getRiskAssessmentRequest = (riskAssessment) => {
  return {
    type: GET_RISK_ASSESSMENT_REQUEST,
    payload: riskAssessment,
  };
};

export const fetchRiskAssessment = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("risk_assessment"));

    try {
      const res = await axiosInstance.get(`/survey/risk_assessment/${orgaId}`);
      const data = res?.data || {};

      dispatch(
        getRiskAssessmentRequest({
          user_choice: data?.user_choice || "",
          hypotheses: Array.isArray(data?.hypotheses) ? data.hypotheses : [],
        })
      );

      dispatch(requestSucceeded());
      return res;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const updateRiskAssessmentHypotheses = (orgaId, ops) => {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_risk_assessment"));
      const res = await axiosInstance.post(`/survey/risk_assessment_ops`, {
        orga_id: Number(orgaId),
        ops,
      });

      dispatch(fetchRiskAssessment(orgaId));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return res.data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
